<template>
  <div class="dialog-wrapper">
    <el-dialog
      v-bind="dialogProps"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      append-to-body
    >

      <el-form
        ref="formRef"
        :model="formModel" 
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="所属菜单:" prop="parentName">
          <el-input v-model="formModel.parentName" disabled/>
        </el-form-item>

        <el-form-item label="权限名称:" prop="name">
          <el-input v-model="formModel.name" placeholder="请输入权限名称" maxlength="32" />
        </el-form-item>

        <el-form-item label="权限地址:" prop="url">
          <el-input v-model="formModel.url" placeholder="请输入权限地址" />
        </el-form-item>

        <el-form-item label="数据范围:" prop="scope">
          <el-checkbox-group v-model="formModel.scope">
            <el-checkbox v-for="item in scopeList" :key="item.id" :label="item.id">{{ item.label }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="权限类型:" prop="type">
          <el-select
            v-model="formModel.type"
            style="width: 100%"
            clearable
            filterable
            placeholder="请选择权限类型"
          >
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="权限标识:" prop="code">
          <el-input v-model="formModel.code" placeholder="请输入权限标识" />
        </el-form-item>

        <el-form-item label="权限描述:" prop="remarks">
          <el-input
            v-model="formModel.remarks"
            :rows="3"
            placeholder="请输入权限描述"
            type="textarea"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="plain" @click="handleClose">关闭</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
const MODE = ['add', 'edit']
const TITLE = ['新增资源点', ' 编辑资源点']
import Services from '@/services/api/backstage'

export default {
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入权限名称', trigger: 'blur' },
        ],
        url: [
          {
            required: true, message: '请输入正确的权限地址("/"开头仅支持英文和数字)', trigger: ['blur', 'change'], pattern: /^\/[A-Za-z0-9]/, 
          },
        ],
        code: [
          {
            required: true, message: '请输入正确的权限标识', trigger: ['blur', 'change'], 
          },
        ],
        type: [
          { required: true, message: '请选择权限类型', trigger: ['blur', 'change'] },
        ],
      },
      dialogProps: {
        visible: false,
        mode: null,
        title: null,
      },
      formModel: {
        parentId: null,
        parentName: null,
        name: null,
        url: null,
        code: null,
        type: null,
        scope: [],
        remarks: null,
      },
      typeList: [
        // {
        //   id: 1,
        //   label: '菜单',
        // },
        {
          id: 2,
          label: 'tab页',
        },
        {
          id: 3,
          label: '控件',
        },
        {
          id: 4,
          label: '业务',
        },
      ],
      scopeList: [
        {
          id: 1,
          label: '个人',
        },
        {
          id: 2,
          label: '团队',
        },
        {
          id: 3,
          label: '团队含下级',
        },
        {
          id: 4,
          label: '全部',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleOpen(menuInfo) {
      const { id, name } = menuInfo
      this.formModel.parentId = id
      this.formModel.parentName = name
      this.dialogProps = {
        visible: true,
        mode: MODE[0],
        title: TITLE[0],
      }
    },
    async handleEdit(menu) {
      const res = await Services.apiQuerySystemTreeDetail({ id: menu.id })

      this.dialogProps = {
        visible: true,
        mode: MODE[1],
        title: TITLE[1],
      }

      this.$nextTick(() => {
        const { children, ...rest } = res.data
        this.formModel = Object.assign(this.formModel, rest)
      })
    },
    handleClose() {
      this.$refs.formRef.resetFields()
      this.dialogProps = {
        visible: false,
        mode: MODE[0],
        title: TITLE[0],
      }
    },

    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()

        if (this.dialogProps.mode === 'add') {
          await Services.apiAddSystemTree(this.formModel)
        } else {
          await Services.apiUpdateSystemTree(this.formModel)
        }
        this.$message.success('操作成功')
        this.$emit('handle-success')
        this.handleClose()
      } catch (error) {
        console.log(error)
      }
    },
  },
};
</script>

<style scoped lang="less"></style>
